var map = {
	"./apple.gif": 273,
	"./apple.png": 642,
	"./candy-trail.gif": 673,
	"./candy-trail.png": 914,
	"./sj-19.gif": 955,
	"./sj-19.png": 372,
	"./slotwo.gif": 305,
	"./slotwo.png": 306,
	"./spooky-ghosts-witch.gif": 199,
	"./spooky-ghosts-witch.png": 272,
	"./thirsty-frog.gif": 443,
	"./thirsty-frog.png": 164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;